import { render, staticRenderFns } from "./GoalDeleteConfirmContainer.vue?vue&type=template&id=40dcb750&"
import script from "./GoalDeleteConfirmContainer.vue?vue&type=script&lang=js&"
export * from "./GoalDeleteConfirmContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports